const PORTFOLIO_LIST = [
	{ label: 'Product Engineering and Digital Growth : pedg', value: 'pedg' },
	{ label: 'Business to Business : dsg', value: 'dsg' },
	{ label: 'Enterprise Data Strategic Services. Formerly EDO : eds', value: 'eds' },
	{ label: 'ISDP : sdp', value: 'sdp' },
	{ label: 'ISG CESO : isg', value: 'isg' },
	{
		label: 'ISG Enterprise Integration Services : isg',
		value: 'isg'
	},
	{ label: 'ISG Enterprise Services : isg', value: 'isg' },
	{
		label: 'ISG Platform Portfolio Management  : isg',
		value: 'isg'
	},
	{ label: 'ISG Risk Management : isg', value: 'isg' },
	{ label: 'NTG : ntg', value: 'ntg' },
	{ label: 'Artificial Intelligence Group : aig', value: 'aig' },
	{ label: 'Finance : fin', value: 'fin' },
	{ label: 'Channel Management : cmg', value: 'cmg' },
	{ label: 'Consumer Mobile Business : cmb', value: 'cmb'},
	{ label: 'Marketing Group : mktg', value: 'mktg'},
	{ label: 'Globe B2B : b2b', value: 'b2b'},
	{ label: 'Customer Experience Creations : cxc', value: 'cxc'},
	{ label: 'Consumer Broadband Business : cbg', value: 'cbg'},
	{ label: 'The Data Group : tdg', value: 'tdg'},
	{ label: 'Feel Valued Tribe : fvt', value: 'fvt'}

]

export default PORTFOLIO_LIST
